import { Logo } from "./Logo";
import { selectTourImageId, selectTourName } from "selectors/Tour";
import { useAppSelector } from "app/hooks";

interface Props {
  id: string;
}

export const TourLogo = ({ id }: Props) => {
  const imageId = useAppSelector((state) => selectTourImageId(state, id));

  const name = useAppSelector((state) => selectTourName(state, id));
  return <Logo key={imageId} id={imageId} title={name} type="Tour" />;
};
